import Model from './Model'

export default class SurveyFormModel extends Model {
  public id: number|undefined

  resource () : string {
    return 'surveys/forms'
  }
}
